import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { NgxMaskModule } from 'ngx-mask';
import { InputComponent } from './input.component';

@NgModule({
	declarations: [InputComponent],
	imports: [SharedModule, NgxMaskModule.forRoot()],
	exports: [InputComponent],
})
export class InputModule {}
